module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "title": "新增代理商",
      "lock-scroll": false,
      "custom-class": ""
    },
    model: {
      value: (_vm.visiable),
      callback: function($$v) {
        _vm.visiable = $$v
      },
      expression: "visiable"
    }
  }, [_c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "isAdd": true,
      "value": _vm.baseInfo,
      "isComShow": true
    },
    on: {
      "showSelectStaffDialog": _vm.showSelectStaffDialog
    }
  }), _vm._v(" "), _c('contact-form', {
    ref: "contact",
    attrs: {
      "value": _vm.contact
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "ptitle"
  }, [_vm._v("代理信息")]), _vm._v(" "), _vm._l((_vm.agentList), function(agent, index) {
    return _c('agent-info', {
      ref: 'agentInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "isHideContractNumber": false,
        "isHideAgentLevel": false,
        "isAdd": true,
        "value": agent,
        "myIndex": (index + 1)
      },
      on: {
        "setEveryAgentInfoOfPolicy": _vm.setEveryAgentInfoOfPolicy,
        "showChoicedAddressDiaolog": function($event) {
          _vm.showChoicedAddressDiaolog(index + 1)
        },
        "delAgentfn": _vm.delAgentfn
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "agentInfo-add-box"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "success"
    },
    on: {
      "click": _vm.addAgentObj
    }
  }, [_vm._v("+ 添加代理区域")])], 1), _vm._v(" "), _c('agentMoney', {
    ref: "refAgentMoney",
    attrs: {
      "value": _vm.agentMoney
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 2), _vm._v(" "), _c('operateAddressDialog', {
    ref: "refOperateAddressDialog",
    attrs: {
      "value": _vm.agentDeliveryAddress
    },
    on: {
      "selectAddress": _vm.selectAddress
    }
  }), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e7c601c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/agent-add/index.vue
// module id = 1537
// module chunks = 1